const MAX_LENGTH = 500;
const MAX_NEW_LINES = 10;

export const stringFormatUtils = {
  removeExtraNewlines(text) {
    if (text == null) {
      text = '';
    }

    return text.replace(/(\n){2,}/g, '\n\n').replace(/(\n)*$/g, '');
  },

  stripTags(text) {
    if (text == null) {
      text = '';
    }

    return $('<p>').html(text).text();
  },

  format(text, truncate, maxLength = MAX_LENGTH) {
    if (text == null) {
      text = '';
    }

    let splitId;
    let formattedText = this.removeExtraNewlines(text);

    if (truncate) {
      if (text.length > maxLength) {
        const shortText = text.substr(0, MAX_LENGTH);
        splitId = Math.max(shortText.lastIndexOf(' '), shortText.lastIndexOf('\n'));
        formattedText = text.substr(0, splitId);
      }

      if (formattedText.split('\n').length - 1 > MAX_NEW_LINES) {
        splitId = formattedText.indexOf('\n');

        for (let i = 1; i <= MAX_NEW_LINES; i += 1) {
          splitId = formattedText.indexOf('\n', splitId + 1);
        }

        formattedText = formattedText.substr(0, splitId);
      }
    }

    return formattedText;
  },

  willTruncate(text, maxLength = MAX_LENGTH) {
    if (text == null) {
      text = '';
    }

    return text.length > maxLength || this.removeExtraNewlines(text).split('\n').length - 1 > MAX_NEW_LINES;
  },

  stripEmojis(str) {
    if (str == null) {
      str = '';
    }
    
    return (
      str
        .replace(
          /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
          ''
        )
        .replace(/\s+/g, ' ')
        .trim()
    );
  },
};
